import moment from 'moment';

export const calculateCompanyPortData = (transits, startDateRange, endDateRange) => {
  const portStats = {};
  const totals = {
    ytd: 0,
    prev: 0,
    diff: 0
  };

  for (const entry of transits || []) {
    const { portId, portName, startDate, vesselName, imo, endDate, timeInPort } = entry;

    if (!portId) continue;

    const arrival = moment(startDate);
    if (!portStats[portId]) {
      portStats[portId] = {
        portId,
        portName,
        ytdPortCalls: 0,
        prevYearYTDPortCalls: 0,
        difference: 0,
        increase: '-',
        ytdModalData: {},
        prevModalData: {}
      };
    }

    const stat = portStats[portId];

    const inYTD = arrival.isBetween(startDateRange, endDateRange);
    const inPrevYTD = arrival.isBetween(
      startDateRange.clone().subtract(1, 'year'),
      endDateRange.clone().subtract(1, 'year')
    );

    const modalKey = `${imo}_${arrival}`;

    if (inYTD) {
      stat.ytdPortCalls++;
      totals.ytd++;
      if (!stat.ytdModalData[modalKey]) {
        stat.ytdModalData[modalKey] = {
          vesselName,
          imo,
          startDate: moment(startDate),
          endDate: moment(endDate),
          timeInPort: timeInPort.toFixed(2),
          year: arrival.year(),
          period: 'YTD',
          portId,
          portName
        };
      }
    }

    if (inPrevYTD) {
      stat.prevYearYTDPortCalls++;
      totals.prev++;
      if (!stat.prevModalData[modalKey]) {
        stat.prevModalData[modalKey] = {
          vesselName,
          imo,
          startDate: moment(startDate),
          endDate: moment(endDate),
          timeInPort: timeInPort.toFixed(2),
          year: arrival.year(),
          period: 'YTD',
          portId,
          portName
        };
      }
    }

    stat.difference = stat.ytdPortCalls - stat.prevYearYTDPortCalls;

    if (stat.prevYearYTDPortCalls) {
      const rawInc = (stat.ytdPortCalls * 100) / stat.prevYearYTDPortCalls;
      const diff = rawInc - 100;
      stat.increase = Number.isInteger(diff) ? diff.toFixed(0) : diff.toFixed(2);
    }
  }

  const tableData = Object.values(portStats).filter(
    (row) => row.ytdPortCalls > 0 || row.prevYearYTDPortCalls > 0
  );

  // Calculate shares
  tableData.forEach((row) => {
    row.ytdPortCallsShare = totals.ytd ? ((row.ytdPortCalls * 100) / totals.ytd).toFixed(2) : '0';

    row.prevYearYTDPortCallsShare = totals.prev
      ? ((row.prevYearYTDPortCalls * 100) / totals.prev).toFixed(2)
      : '0';

    row.differenceShare = totals.diff ? ((row.difference * 100) / totals.diff).toFixed(2) : '0';

    if (row.prevYearYTDPortCallsShare !== '0') {
      const inc =
        (parseFloat(row.ytdPortCallsShare) * 100) / parseFloat(row.prevYearYTDPortCallsShare);
      row.increaseShare = (inc - 100).toFixed(2);
    } else {
      row.increaseShare = '-';
    }
  });

  return tableData.sort((a, b) => b.ytdPortCalls - a.ytdPortCalls);
};

export const getTop10Calls = (list, valueKey, shareKey, includeOthers = true) => {
  // Step 1: Copy the list so we don't mess with the original
  const sortedList = [...list];

  // Step 2: Sort it from biggest to smallest based on the property you give
  sortedList.sort((a, b) => {
    return Number(b[valueKey]) - Number(a[valueKey]);
  });

  // Step 3: Grab the first 10 items
  const top10 = sortedList.slice(0, 10);

  if (!includeOthers) {
    return top10;
  }

  // Step 4: Get everything else after the top 10
  const others = sortedList.slice(10);

  // Step 5: Add up the shares from the "others" group
  let othersTotalShare = 0;
  for (let i = 0; i < others.length; i++) {
    const share = Number(others[i][shareKey]) || 0;
    othersTotalShare += share;
  }

  // Step 6: Add up the values from the "others" group
  let othersTotalValue = 0;
  for (let i = 0; i < others.length; i++) {
    const value = Number(others[i][valueKey]) || 0;
    othersTotalValue += value;
  }

  // Step 7: If we actually have any "others", add them to the end
  if (others.length > 0) {
    top10.push({
      portId: 0,
      portName: 'Others',
      [valueKey]: othersTotalValue,
      [shareKey]: othersTotalShare.toFixed(2),
      prevModalData: {},
      ytdModalData: {},
      difference: 0,
      increase: '-',
      increaseShare: '-'
    });
  }

  // All done!
  return top10;
};

export const getDisplayValue = (val) => {
  return Number.isInteger(val) ? val.toFixed(0) : val.toFixed(2);
};
